var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddCircledOutlineDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5104_16448)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4296 23.5114C6.81729 19.8991 6.81729 14.0423 10.4296 10.43C14.042 6.81762 19.8988 6.81762 23.5111 10.43C27.1235 14.0423 27.1235 19.8991 23.5111 23.5114C19.8988 27.1238 14.042 27.1238 10.4296 23.5114ZM9.36898 9.36931C5.17084 13.5674 5.17084 20.374 9.36898 24.5721C13.5671 28.7702 20.3736 28.7702 24.5718 24.5721C28.7699 20.374 28.7699 13.5674 24.5718 9.36931C20.3736 5.17117 13.5671 5.17117 9.36898 9.36931ZM12.9701 16.221C12.5559 16.221 12.2201 16.5568 12.2201 16.971C12.2201 17.3852 12.5559 17.721 12.9701 17.721L16.2201 17.721L16.2201 20.971C16.2201 21.3852 16.5559 21.721 16.9701 21.721C17.3843 21.721 17.7201 21.3852 17.7201 20.971V17.721L20.9701 17.721C21.3843 17.721 21.7201 17.3852 21.7201 16.971C21.7201 16.5568 21.3843 16.221 20.9701 16.221H17.7201V12.971C17.7201 12.5568 17.3843 12.221 16.9701 12.221C16.5559 12.221 16.2201 12.5568 16.2201 12.971L16.2201 16.221H12.9701Z",
    fill: "#A7A7A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5104_16448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 16.9707) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircledOutlineDisabled);
export default __webpack_public_path__ + "static/media/addCircledOutlineDisabled.52e464ea2e37b2bce6bf27bf4f6400b5.svg";
export { ForwardRef as ReactComponent };